import { useUserProfile as c } from "@dcentralexpedientedigital/fe-pam-api/hooks/use-user-profile";
import { useIntlStore as d } from "../stores/intl-store.js";
import { getMarketFromLocale as i } from "../utils/locale.js";
import { useAuth as O } from "./use-auth.js";
const t = {
  NORWEGIAN: "NO",
  REST_OF_WORLD: "EN"
}, f = () => {
  var u, a;
  const { auth: e } = O(), o = (a = (u = e.user) == null ? void 0 : u.profile) == null ? void 0 : a.sub, { data: r } = c({ userId: o ?? "", pause: !o }), s = d((n) => n.locale);
  return e.isAuthenticated && (r != null && r.addressCountryAlpha2Code) ? r.addressCountryAlpha2Code === t.NORWEGIAN ? t.NORWEGIAN : t.REST_OF_WORLD : s ? i(s) : t.REST_OF_WORLD;
};
export {
  t as MARKETS,
  f as useMarket
};
